<template>
	<div>
		<el-divider content-position="left" border-style="dotted">Filter</el-divider>
		<el-form :model="logFilter" label-width="auto" label-position="top" :disabled="downloading">
			<div class="row g-3">
				<div class="col-12 col-sm-6 col-lg-3">
					<el-form-item label="Non-GTK" prop="user_presensi_id" class="mb-0">
						<el-select v-model="logFilter.user_presensi_id" filterable placeholder="Pilih non-gtk" clearable>
							<el-option v-for="u in listUser" :key="u.non_gtk_id" :label="`${u.nama} (${u.user_presensi_id})`" :value="u.user_presensi_id" />
						</el-select>
					</el-form-item>
				</div>
				<div class="col-12 col-sm-6 col-lg-3">
					<el-form-item label="Mesin" prop="mesin_presensi_id" class="mb-0">
						<el-select v-model="logFilter.mesin_presensi_id" filterable placeholder="Pilih mesin presensi" clearable>
							<el-option v-for="m in listMesin" :key="m._key" :label="`${m.nama} (${m.keterangan})`" :value="m.mesin_presensi_id" />
						</el-select>
					</el-form-item>
				</div>
				<div class="col-12 col-lg-6">
					<el-form-item label="Tanggal" prop="tanggal" class="mb-0">
						<el-date-picker
							v-model="logFilter.tanggal"
							type="daterange"
							range-separator="s/d"
							format="DD MMMM YYYY"
							value-format="YYYY-MM-DD"
							start-placeholder="Tanggal Awal"
							end-placeholder="Tanggal Akhir" />
					</el-form-item>
				</div>
			</div>
			<el-form-item v-if="isPetugasPresensi" class="mt-3">
				<el-button @click="downloadLogPresensi" round type="success" icon="Download" class="ms-auto" :loading="downloading">Unduh data riwayat presensi</el-button>
			</el-form-item>
		</el-form>
		<el-divider border-style="dotted" />
		<el-table :data="logPresensi" row-key="log_presensi_id" table-layout="auto" v-loading="loading">
			<template #empty>
				<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
			</template>
			<el-table-column type="index" label="No." :index="indexMethod" />
			<el-table-column label="Nama" prop="nama">
				<template #default="{ row }">
					<div class="hstack gap-1 justify-content-between">
						<span>{{ row.nama }}</span>
						<el-tooltip :content="row.is_confirmed ? 'Kontak terkonfirmasi' : 'Belum konfirmasi'" placement="right">
							<transition name="fade" mode="out-in">
								<el-icon v-if="row.is_confirmed" class="text-bg-success rounded-circle"><CircleCheck /></el-icon>
								<el-icon v-else class="text-warning"><Warning /></el-icon>
							</transition>
						</el-tooltip>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="ID Presensi" prop="user_presensi_id">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Mesin" prop="mesin_presensi_id">
				<template #default="{ row }">
					<transition name="fade" mode="out-in">
						<span :key="`${row.nama_mesin}_${row.ket_mesin}`">{{ row.nama_mesin }} · {{ row.ket_mesin }}</span>
					</transition>
				</template>
			</el-table-column>
			<el-table-column label="Hari/Tanggal" prop="tanggal_presensi" />
			<el-table-column label="Waktu" prop="waktu" />
		</el-table>
		<el-pagination
			class="flex-wrap justify-content-center mt-3"
			v-model:current-page="currentPage"
			v-model:page-size="pageSize"
			:page-sizes="[5, 10, 25, 50, 100]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalData"
			@change="getLogPresensi" />
	</div>
</template>

<script>
export default {
	name: "RiwayatNonGtk",
	data() {
		return {
			logPresensi: [],
			listUser: [],
			logFilter: {
				user_presensi_id: null,
				mesin_presensi_id: null,
				tanggal: null,
			},
			debounceFetch: null,
			loading: true,
			downloading: false,
			currentPage: 1,
			totalData: 0,
			pageSize: 10,
		};
	},
	props: {
		listMesin: Array,
		isPetugasPresensi: Boolean,
	},
	computed: {},
	watch: {
		"logFilter.user_presensi_id"() {
			clearTimeout(this.debounceFetch);

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getLogPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"logFilter.mesin_presensi_id"() {
			clearTimeout(this.debounceFetch);

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getLogPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"logFilter.tanggal"(newVal, oldVal) {
			if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
			
			clearTimeout(this.debounceFetch);

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getLogPresensi();
				else this.currentPage = 1;
			}, 0);
		},
	},
	mounted() {
		this.$ws.main.on("log:inserted", this.insertedLog);
		this.$ws.main.on("user:non-gtk:inserted", this.insertedUserPresensi);
		this.$ws.main.on("user:non-gtk:updated", this.updatedUserPresensi);
		this.$ws.main.on("user:non-gtk:deleted", this.deletedUserPresensi);
		this.$ws.main.on("mesin:updated", this.updatedMesinPresensi);
		this.getLogPresensi();
		this.getListUserPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("log:inserted");
		this.$ws.main.off("user:non-gtk:inserted");
		this.$ws.main.off("user:non-gtk:updated");
		this.$ws.main.off("user:non-gtk:deleted");
		this.$ws.main.off("mesin:updated");
	},
	methods: {
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		indexMethod(index) {
			return (this.currentPage - 1) * this.pageSize + index + 1;
		},
		insertedLog(data) {
			const d = JSON.parse(data);

			if (d.type !== "non_gtk") return;
			if (this.logFilter.user_presensi_id && this.logFilter.user_presensi_id !== d.user_presensi_id) return;
			if (this.logFilter.mesin_presensi_id && Number(this.logFilter.mesin_presensi_id) !== Number(d.mesin_presensi_id)) return;
			if (Array.isArray(this.logFilter.tanggal)) {
				const scan = this.toWIB(d.waktu_presensi);
				const awal = new Date(this.logFilter.tanggal[0] + "T00:00:00+07:00");
				const akhir = new Date(this.logFilter.tanggal[1] + "T23:59:59.999+07:00");

				if (scan < awal || scan > akhir) return;
			}

			this.totalData++;

			if (this.logPresensi.length === this.pageSize) return;

			this.loading = true;

			const mesin = this.listMesin.filter((m) => m.mesin_presensi_id === d.mesin_presensi_id)[0] || {};
			const newLog = {
				...d,
				nama_mesin: mesin.nama,
				ket_mesin: mesin.keterangan,
				tanggal_presensi: new Date(d.waktu_presensi).toLocaleDateString("id-ID", { dateStyle: "full" }),
				waktu: new Date(d.waktu_presensi).toLocaleTimeString("id-ID", { timeStyle: "medium" }),
			};

			this.logPresensi.push(newLog);

			setTimeout(() => {
				this.loading = false;
			}, 500);
		},
		insertedUserPresensi(data) {
			const d = JSON.parse(data);
			const temp = [...this.listUser];

			temp.push({
				user_presensi_id: d.user_presensi_id,
				non_gtk_id: d.non_gtk_id,
				nama: d.nama,
			});
			temp.sort((a, b) => {
				return a.nama.localeCompare(b.nama);
			});

			const checkIndex = temp.findIndex((t) => t.user_presensi_id === d.user_presensi_id);

			this.listUser.splice(checkIndex, 0, {
				user_presensi_id: d.user_presensi_id,
				non_gtk_id: d.non_gtk_id,
				nama: d.nama,
			});
		},
		updatedUserPresensi(data) {
			const d = JSON.parse(data);

			this.listUser.every((u) => {
				if (u.non_gtk_id === d.non_gtk_id) {
					if (d.user_presensi_id) u.user_presensi_id = d.user_presensi_id;

					return false;
				}
				return true;
			});
			this.logPresensi.forEach((l) => {
				if (l.non_gtk_id === d.non_gtk_id) {
					if (d.user_presensi_id) l.user_presensi_id = d.user_presensi_id;
					if (typeof d.is_confirmed === "number") l.is_confirmed = d.is_confirmed;
				}
			});
		},
		deletedUserPresensi(data) {
			const d = JSON.parse(data);
			const oldUserIndex = this.userPresensi.findIndex((u) => u.user_presensi_id === d.user_presensi_id);
			if (oldUserIndex !== -1) this.listUser.splice(oldUserIndex, 1);
		},
		updatedMesinPresensi(data) {
			const d = JSON.parse(data);

			this.logPresensi.forEach((l) => {
				if (Number(l.mesin_presensi_id) === Number(d.old_mesin_presensi_id)) {
					if (d.mesin_presensi_id) l.mesin_presensi_id = d.mesin_presensi_id;
					if (d.nama) l.nama_mesin = d.nama;
					if (d.keterangan) l.ket_mesin = d.keterangan;
				}
			});
		},
		async getLogPresensi() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.post("/log", {
					user_presensi_type: "non_gtk",
					user_presensi_id: this.logFilter.user_presensi_id,
					mesin_presensi_id: this.logFilter.mesin_presensi_id,
					tanggal_awal: Array.isArray(this.logFilter.tanggal) ? this.logFilter.tanggal[0] : null,
					tanggal_akhir: Array.isArray(this.logFilter.tanggal) ? this.logFilter.tanggal[1] : null,
					limit: this.pageSize,
					offset: (this.currentPage - 1) * this.pageSize,
				});

				const logs = data.logs.map((l) => ({
					...l,
					tanggal_presensi: new Date(l.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
				}));

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.logPresensi = logs;
				this.totalData = data.count;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.loading = false;
			}
		},
		async getListUserPresensi() {
			try {
				const { data } = await this.$defaultApi.post("/user/list", {
					user_presensi_type: "non_gtk",
				});

				this.listUser = data.list_user;
			} catch (error) {
				console.error(error);
			}
		},
		async downloadLogPresensi() {
			this.downloading = true;
			try {
				const { data, headers } = await this.$defaultApi.post(
					"/log/download",
					{
						user_presensi_type: "non_gtk",
						user_presensi_id: this.logFilter.user_presensi_id,
						mesin_presensi_id: this.logFilter.mesin_presensi_id,
						tanggal_awal: Array.isArray(this.logFilter.tanggal) ? this.logFilter.tanggal[0] : null,
						tanggal_akhir: Array.isArray(this.logFilter.tanggal) ? this.logFilter.tanggal[1] : null,
					},
					{
						responseType: "blob",
					}
				);

				const contentDisposition = headers["content-disposition"];
				let fileName = "DataRiwayatPresensi.xlsx";

				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						fileName = decodeURIComponent(match[1]);
					}
				}

				const url = window.URL.createObjectURL(new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

				const a = document.createElement("a");
				a.href = url;
				a.download = fileName;
				document.body.appendChild(a);

				await new Promise((resolve) => setTimeout(resolve, 500));
				a.click();
				a.remove();
				window.URL.revokeObjectURL(url);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.downloading = false;
			}
		},
	},
};
</script>

<style scoped></style>
